<template>
  <div>
    <Head title="Termos e Privacidade" />
    <div class="shadow_box rounded-lg p-6">
        <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Termos de Uso e Política de Privacidade</h1>
        <form @submit.prevent="update">
            <div class="flex flex-wrap mb-4 px-4">
                <textarea-input v-model="form.terms_privacity" :error="form.errors.terms_privacity" class="pb-8 w-full" />
            </div>
            <div class="">
                <loading-button :loading="form.processing" class="btn-blue" type="submit">Salvar</loading-button>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    TextareaInput,
  },
  props: {
    terms_privacity: String,
  },
  remember: 'form',
  data() {
    return {
      form: useForm({
        terms_privacity: this.terms_privacity,
      }),
    }
  },
  layout: Layout,
  methods: {
    update() {
      this.form.put(`/terms`)
    },
  },
}
</script>
